import { NgModule } from '@angular/core';
import { DropdownComponent } from './dropdown.component';
import { DropdownAnchorDirective } from './dropdown-anchor.directive';
import { DropdownItemDirective } from './dropdown-item.directive';
import { DropdownNavigatorDirective } from './dropdown-navigator.directive';
import { DropdownStateDirective } from './dropdown-state.directive';

const contents = [
  DropdownComponent,
  DropdownAnchorDirective,
  DropdownItemDirective,
  DropdownNavigatorDirective,
  DropdownStateDirective,
];

@NgModule({
  imports: contents,
  exports: contents,
})
export class DropdownModule {}
